export default __webpack_public_path__ + "static/media/excel_white.e1ccd2f8.png";